<template>
  <table class="table">
    <thead>
      <slot name="columns">
        <tr>
          <th v-for="column in columns"  v-if="filtrarColunas(tipoPesquisa, column)" :key="column"> 
            <a v-if="column != 'Historico'"  href="#" @click="orderByTableClick(column)">{{ changeLabel(column) }}</a>
            <p v-if="column == 'Historico'" class="ft-12 p-0 m-0">{{ changeLabel(column) }}</p>
            <i v-if="((column == orderColumn) && !crescentOrder)" class="fa fa-arrow-down d-inline" aria-hidden="true"></i>
            <i v-if="((column == orderColumn) && crescentOrder)" class="fa fa-arrow-up d-inline" aria-hidden="true"></i>
         </th>
        </tr>
      </slot>
    </thead>
    <tbody>
      <tr v-for="(item, index) in data" :key="index">
        <slot :row="item">
          <td class="icon-td">
            <a class="nc-icon-ml-30" href="#" @click.prevent="createHistoric"
              ><i
                :id="item.PROCESS"
                :name="item.LAST_STATUS"
                class="nc-icon nc-square-pin text-success "
              ></i
            ></a>
          </td>
          <td
            v-for="column in columns"
            :key="column"
            v-if="(hasValue(item, column) && column != 'Historico') && filtrarColunas(tipoPesquisa,column)"
          >
            <p :class="changeColorByStatus(itemValue(item, column),column) + ' p14'">
              {{ itemValue(item, column) || loading }}
            </p>
          </td>
        </slot>
      </tr>
    </tbody>
  </table>
</template>
<script>
import json from './Filters/filterColumn.json';
export default {
  name: "h-table",
  props: {
    columns: Array,
    data: Array,
    loading: String,
    tipoPesquisa: String,
    orderColumn: String,
    crescentOrder: Boolean,
  },
  data() {
    return {
      processoSelecionado: ""
    };
  },
  methods: {
    hasValue(item, column) {
      return item[column.toUpperCase()] !== "undefined";
    },
    itemValue(item, column) {
      return item[column.toUpperCase()];
    },
    changeLabel(item){
      switch (item) {
        case 'LAST_STATUS':
          return 'STATUS'
        break;
        
        case 'CLIENT_REF':
          return 'REFERÊNCIA'
        break;

        case 'PROCESS':
          return 'PROCESSO'
        break;

        case 'ORIGIN':
          return 'ORIGEM'
        break;

        case 'DESTINATION':
          return 'DESTINO'
        break;

        case 'PO':
          return 'NUM.PO'
        break;
        
        default:
          return item;
        break;
      }
    },
    changeColorByStatus(txt,column) {
      if(column == "LAST_STATUS"){
        txt = txt.toUpperCase().trim();
        switch (txt) {
          case "AGUARDANDO EMBARQUE":
            return "orange text-uppercase";
            break;

          case "EM TRANSITO":
            return "yellow text-uppercase";
            break;

          case "SAIDA CONFIRMADA":
            return "purple text-uppercase";
            break;

          case "CHEGADA CONFIRAMADA":
            return "green text-uppercase";
            break;

          case "FINALIZADO":
            return "black text-uppercase";
            break;

          case "STATUS ESPECIFICOS":
            return "blue text-uppercase";
            break;

          default:
            return "black text-uppercase"
            break;
        }
      }
    },
    filtrarColunas(tipoPesquisa, column){
      if(json.hasOwnProperty(tipoPesquisa)){
        if(json[tipoPesquisa].includes(column) ){
          console.log(tipoPesquisa + " | " + column);
          return false;
        }
        return true;
      }
      return true;
    },
    createHistoric(e) {
      let data = {
        processo: e.target.id,
        last_status: e.target.getAttribute("name")
      }
      if(data.processo != "" || data.processo != null){
        this.$emit("click", data);
      }
      
    },
    orderByTableClick(column){
      console.log(this.crescentOrder);
      if(column != "" || column != null){
        this.$emit("orderby", column);
      }
    }
  }
};
</script>
<style>
.nc-icon-ml-30 {
  margin-left: 30%;
}
.p14 {
  font-size: 12px;
  margin-bottom: 0px;
}
td {
  max-width: 150px;
  padding: 5px 8px 5px 15px !important;
  vertical-align: top !important; 
}
.icon-td{
  width: 20px;
}
.ft-12{
  font-size: 12px;
}
</style>
